/*
 * Filename: panel.js
 * Responsible all cmponent with headding
 * and child components
 */

import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import classNames from 'classnames';
import { connect } from 'react-redux';

const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

class KPIPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,    
    };
  }
  
  handleOnRequestChange = (e,value) => {
    let billableKPItitle = "Billable Hours";
    let billableKPIsubtitle = "*This chart displays rendered billable hours. All locations, payers, appointment types, staff, and clients are shown by default if none are selected.";

    if(value === 'Billable Hours')
    {
      billableKPItitle = "Billable Hours";
      billableKPIsubtitle = "*This chart displays rendered billable hours. All locations, payers, appointment types, staff, and clients are shown by default if none are selected.";
    } 
    else if(value === 'Non-Billable Hours')
    {
      billableKPItitle = "Non-Billable Hours";
      billableKPIsubtitle = "*This chart displays rendered non-billable hours. All locations, payers, appointment types, staff, and clients are shown by default if none are selected.";
    }
    else if(value === 'Cancelled Hours')
    {
      billableKPItitle = "Cancelled Hours";
      billableKPIsubtitle = "*This chart displays rendered cancelled hours. All locations, payers, appointment types, staff, and clients are shown by default if none are selected.";
    }
    else if(value === 'Percentage of Cancellations')
    {
      billableKPItitle = "Percentage of Cancellations";
      billableKPIsubtitle = "*This chart displays rendered cancelled percentage. All locations, payers, appointment types, staff, and clients are shown by default if none are selected.";
    }
    else if(value === 'All Hours')
    {
      billableKPItitle = "All Hours";
      billableKPIsubtitle = "*Pending reflects sessions where the user has entered their notes, but has not clicked the complete button. Scheduled reflects sessions that do have any session notes.";
    }
    
    this.props.handleChangeBillableKPI(billableKPItitle,billableKPIsubtitle);
  }

  render() {
    const panelClass = classNames ({
      'readmin-panel' : true,
      'righticonmenu': true,
      'body-text-center': this.props.center
    });

    // let { userImage, welcomeNote } = this.props;
    return (
      <div className={panelClass}>
        <div className="panel-mainheading">
          <h5>Scheduling Graphs</h5>
        </div>
        <div className="panel-heading panel-heading-withsubtitle">
          <h5>{this.props.billableKPItitle}</h5>
          {/* <h7>{props.billableKPIsubtitle}</h7> */}
          
          { this.props.righticon ? 
            <IconMenu
              //{...props}
              iconButtonElement={
              <IconButton><i className="material-icons">more_vert</i></IconButton>
              }
              targetOrigin={{horizontal: 'right', vertical: 'top'}}
              anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            >
              <MenuItem primaryText="Billable Hours" onClick={(e) => this.handleOnRequestChange(e,'Billable Hours')}/>
              <MenuItem primaryText="Non-Billable Hours" onClick={(e) => this.handleOnRequestChange(e,'Non-Billable Hours')}/>
              <MenuItem primaryText="Cancelled Hours" onClick={(e) => this.handleOnRequestChange(e,'Cancelled Hours')}/>
              <MenuItem primaryText="% of Cancellations" onClick={(e) => this.handleOnRequestChange(e,'Percentage of Cancellations')}/>               
              <MenuItem primaryText="All Hours" onClick={(e) => this.handleOnRequestChange(e,'All Hours')}/>          
              {/* <MenuItem primaryText="List 4" /> */}
            </IconMenu>
          : null}
        </div>
        <div className="panel_title_billablekpi">
          <h7 style={styles.font}>{this.props.billableKPIsubtitle}</h7>
        </div>
        <div className="panel-body">
          {this.props.children}
        </div>
      </div>
    ); 
  }
}
const mapStateToProps = (state) => {
  return {
    loginUserInfo: state.login.loginUserInfo, 
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
};

export default connect(mapStateToProps, { })(KPIPanel);




// WEBPACK FOOTER //
// ./src/adminCharts/KPIPanelToolTip.js